import React from 'react';
import { Link } from 'react-router-dom';
import { LifeBuoy, GraduationCap, ArrowRight } from 'lucide-react';

const TwoPillarsSection: React.FC = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-ifind-charcoal mb-4">
            Two Paths. One Journey.
          </h2>
          <p className="text-gray-600">
            Whether you need someone to talk to today, or want to walk a longer path of inner mastery —
            Soulversity is built for both.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto">
          {/* Get Support */}
          <Link
            to="/experts"
            className="group bg-white rounded-2xl p-8 border border-gray-100 hover:border-ifind-teal/40 transition-all"
          >
            <div className="w-14 h-14 rounded-full bg-ifind-teal/10 flex items-center justify-center mb-5">
              <LifeBuoy className="h-7 w-7 text-ifind-teal" />
            </div>
            <h3 className="text-2xl font-semibold text-ifind-charcoal mb-3">Get Support</h3>
            <p className="text-gray-600 mb-5">
              Speak your heart, book sessions, or connect instantly with live experts for guidance
              tailored to your situation.
            </p>
            <span className="inline-flex items-center text-ifind-teal font-medium group-hover:gap-3 gap-2 transition-all">
              Explore live experts <ArrowRight className="h-4 w-4" />
            </span>
          </Link>

          {/* Learn */}
          <a
            href="#learn"
            className="group bg-white rounded-2xl p-8 border border-gray-100 hover:border-ifind-purple/40 transition-all"
          >
            <div className="w-14 h-14 rounded-full bg-ifind-purple/10 flex items-center justify-center mb-5">
              <GraduationCap className="h-7 w-7 text-ifind-purple" />
            </div>
            <h3 className="text-2xl font-semibold text-ifind-charcoal mb-3">Learn at Soulversity</h3>
            <p className="text-gray-600 mb-5">
              Mindfulness Meditation Teacher Training, Sound Healing Mastery, and full-length
              Bachelor & Master programs in Meditation & Mindfulness.
            </p>
            <span className="inline-flex items-center text-ifind-purple font-medium group-hover:gap-3 gap-2 transition-all">
              Explore courses <ArrowRight className="h-4 w-4" />
            </span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default TwoPillarsSection;
